import { Component, OnInit } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { CampaignService } from '../../services/campaign.service';
import { TelephonyStateService } from '../../providers/telephony/telephony.state.service';

@Component({
  selector: 'app-contact-info',
  templateUrl: './contact-info.component.html',
  animations: [
    trigger('smoothCollapse', [
      state(
        'initial',
        style({
          height: '50px',
          overflow: 'hidden',
          //opacity: '0',
        })
      ),
      state(
        'final',
        style({
          overflow: 'hidden',
          opacity: '1',
        })
      ),
      transition('initial=>final', animate('750ms')),
      transition('final=>initial', animate('750ms')),
    ]),
  ],
})
export class ContactInfoComponent implements OnInit {
  constructor(public campaignService: CampaignService, public telephonyState: TelephonyStateService) {}

  cardCollapseState = {
    ProfileNumbers: false,
    ContactInfo: false,
    CallInfo: false,
    ContactNote: false,
  };

  ngOnInit(): void {}

  onCollapse(selectedCollapse: string) {
    // console.log(new Date().toLocaleString() + '  ➤  onCollapse - selectedCollapse => ', selectedCollapse);
    for (const key in this.cardCollapseState) {
      if (key === selectedCollapse) {
        (this.cardCollapseState as any)[key] = !(this.cardCollapseState as any)[key];
      }
    }
  }
}
